import styled from "styled-components";

export const ImportViewWrapper = styled.div`
    max-width: 100%;
`;
